module.exports = "<div\n\tclass=\"uikit-icon-wrapper\"\n\t[ngClass]=\"uikitClass\"\n\t[innerHTML]=\"svgHtml\">\n</div>"